import { render, staticRenderFns } from "./text-input.vue?vue&type=template&id=98a601f0&scoped=true&"
import script from "./text-input.vue?vue&type=script&lang=js&"
export * from "./text-input.vue?vue&type=script&lang=js&"
import style0 from "./text-input.vue?vue&type=style&index=0&id=98a601f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a601f0",
  null
  
)

export default component.exports